import React, { useEffect, useState } from 'react';
import { api } from '../../../fetch/bussiness/api';
import { CLSTAG } from '../../../utils/constant';
import { clstagStr } from '../../../utils/util';
import { TakeOverStatus } from '@/views/PatrolMode/types';
import { message, Modal } from 'antd';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { request } from '@/fetch/core';
import { HttpStatusCode } from '@/fetch/core/constant';
import { reportSgmEvent, SgmEventType } from '@/utils/sgm';
interface Props {
  isStoped: boolean;
  speed: number;
  disabled: boolean;
  operatorIsSelf: boolean;
  takeOverStatus: string;
  vehicleName: string | string[] | undefined;
  operateRequest: (name: string) => void;
  onShowMessage: (name: string) => void;
}

const StopOrRecovery = (props: Props) => {
  const {
    isStoped,
    disabled,
    operatorIsSelf,
    takeOverStatus,
    speed,
    vehicleName,
  } = props;
  const login = useSelector((state: RootState) => state.login);
  const [permittedUser, setPermittedUser] = useState<string[]>([]);
  const getPermittedUser = async () => {
    const res = await request({
      method: 'POST',
      path: '/monitor/web/basic/user_config',
    });
    if (res.code === HttpStatusCode.Success) {
      setPermittedUser(res.data?.permittedUserList || []);
    } else {
      message.error(res.message);
    }
  };
  useEffect(() => {
    getPermittedUser();
  }, []);

  const reportClick = (action: string, confirmStage: string) => {
    reportSgmEvent({
      type: SgmEventType.INFO,
      code: 'monitor_single_vehicle_command_click',
      msg: {
        page: 'single_vehicle',
        vehicleName: typeof vehicleName === 'string' ? vehicleName : '',
        action,
        trigger: 'click',
        requestId: null,
        result: 'clicked',
        confirm_stage: confirmStage,
      },
    });
  };
  const reportConfirmResult = (action: string, result: string) => {
    reportSgmEvent({
      type: SgmEventType.INFO,
      code: 'monitor_single_vehicle_command_click',
      msg: {
        page: 'single_vehicle',
        vehicleName: typeof vehicleName === 'string' ? vehicleName : '',
        action,
        trigger: 'click',
        requestId: null,
        result,
        confirm_stage: 'speed_confirm',
      },
    });
  };
  const onClickStopBtn = () => {
    if (disabled) {
      return;
    }
    // 如果用户是允许用户，则直接接管
    if (permittedUser.includes(login.user.username)) {
      reportClick('emergency_stop', 'whitelist');
      props.operateRequest(api.emergencyStop);
      return;
    }
    // 判断车辆速度，如果速度超过限制，则弹窗强提示用户，用户必须确认信息后才可以接管
    if (speed > 1.5) {
      reportClick('emergency_stop', 'speed_confirm');
      Modal.confirm({
        title: '提示',
        content: (
          <span>
            当前车辆速度已超过
            <span style={{ color: 'red', fontWeight: 'bold' }}>5.4km/h</span>
            ，请确保周围行人车辆安全的情况下再进行接管!
          </span>
        ),
        onOk: () => {
          reportConfirmResult('emergency_stop', 'confirmed');
          props.operateRequest(api.emergencyStop);
        },
        onCancel: () => {
          reportConfirmResult('emergency_stop', 'cancelled');
          return;
        },
      });
      return;
    } else {
      reportClick('emergency_stop', 'direct');
      props.operateRequest(api.emergencyStop);
    }
  };

  const onClickRecoveryBtn = () => {
    if (disabled) {
      return;
    }
    reportClick('recovery', 'takeover_modal');
    props.onShowMessage('takeover');
  };

  return (
    <>
      {!isStoped ? (
        <>
          <li
            className={disabled ? 'item stop-no-operate' : 'item stop'}
            onClick={onClickStopBtn}
            clstag={clstagStr(CLSTAG.StopBtnClick)}
          >
            <h3 className="tit stop-title">{'急 停'}</h3>
          </li>
        </>
      ) : (
        <>
          {operatorIsSelf && takeOverStatus === TakeOverStatus.TAKEOVER ? (
            <li
              className={
                disabled ? 'item stop-no-operate ' : 'item stop-active'
              }
              onClick={onClickRecoveryBtn}
              clstag={clstagStr(CLSTAG.RecoverBtnClick)}
            >
              <h3 className="tit stop-title">恢 复</h3>
            </li>
          ) : operatorIsSelf && takeOverStatus === TakeOverStatus.TEMPORARY ? (
            <>
              <li
                className={disabled ? 'item stop-no-operate' : 'item stop'}
                onClick={onClickStopBtn}
                clstag={clstagStr(CLSTAG.StopBtnClick)}
              >
                <h3 className="tit stop-title">{'急 停'}</h3>
              </li>
            </>
          ) : (
            <li className={'item stop-no-operate'}>
              <h3 className="tit stop-title">恢 复</h3>
            </li>
          )}
        </>
      )}
    </>
  );
};
export default StopOrRecovery;
